// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".red-text {\n  color: red;\n  text-transform: capitalize;\n}\n.el-select .el-select__tags > span {\n  flex-wrap: wrap !important;\n}\n.order-reason-change-model .el-select__tags {\n  flex-wrap: wrap !important;\n}", ""]);
// Exports
module.exports = exports;
